<div class="space-y-6 pb-6">
  <!-- ── Header ── -->
  <div>
    <h1 class="text-2xl font-bold text-gray-900 dark:text-gray-100">
      {{ 'REPORTS.TITLE' | translate }}
    </h1>
    <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
      {{ 'REPORTS.SUBTITLE' | translate }}
    </p>
  </div>

  <!-- ── Filters ── -->
  <div
    class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-4 shadow-sm"
  >
    <div class="grid grid-cols-2 lg:grid-cols-3 gap-3">
      <div class="flex flex-col gap-1">
        <span class="text-xs font-medium text-gray-500 dark:text-gray-400">{{
          'REPORTS.FROM' | translate
        }}</span>
        <p-datepicker
          [(ngModel)]="filterFrom"
          dateFormat="dd.mm.yy"
          [showIcon]="true"
          [iconDisplay]="'input'"
          styleClass="w-full"
          inputStyleClass="text-sm"
          appendTo="body"
        />
      </div>

      <div class="flex flex-col gap-1">
        <span class="text-xs font-medium text-gray-500 dark:text-gray-400">{{
          'REPORTS.TO' | translate
        }}</span>
        <p-datepicker
          [(ngModel)]="filterTo"
          dateFormat="dd.mm.yy"
          [showIcon]="true"
          [iconDisplay]="'input'"
          styleClass="w-full"
          inputStyleClass="text-sm"
          appendTo="body"
        />
      </div>

      <!-- Bitta do'konda filtr yashiriladi: "hammasi" bilan bir xil natija beradi. -->
      @if (storePick.visible()) {
        <div class="flex flex-col gap-1 col-span-2 lg:col-span-1">
          <span class="text-xs font-medium text-gray-500 dark:text-gray-400">{{
            'REPORTS.STORE' | translate
          }}</span>
          <p-multiselect
            [(ngModel)]="selectedStoreIds"
            [options]="stores()"
            optionLabel="name"
            optionValue="id"
            [placeholder]="'REPORTS.ALL_STORES' | translate"
            styleClass="w-full"
            display="chip"
            appendTo="body"
          />
        </div>
      }

      <!-- Faqat bir nechta valyuta yoqilgan bo'lsa chiqadi — bitta valyutali
           biznesda ekran avvalgidek qoladi. Bo'sh = tenant kotirovka valyutasi. -->
      @if (currencySvc.hasMultipleCurrencies()) {
        <div class="flex flex-col gap-1">
          <span class="text-xs font-medium text-gray-500 dark:text-gray-400">{{
            'REPORTS.CURRENCY' | translate
          }}</span>
          <p-select
            [(ngModel)]="selectedCurrency"
            [options]="currencySvc.currencyOptions()"
            optionLabel="label"
            optionValue="value"
            [showClear]="true"
            [placeholder]="currencySvc.defaultCode()"
            styleClass="w-full"
            appendTo="body"
          />
        </div>
      }
    </div>
    <div class="flex items-center justify-between gap-3 mt-3">
      <p class="text-xs text-gray-400 dark:text-gray-500">
        {{ 'REPORTS.HINT' | translate }}
      </p>
      <p-button
        [label]="'REPORTS.CLEAR' | translate"
        icon="pi pi-filter-slash"
        severity="secondary"
        [text]="true"
        size="small"
        styleClass="shrink-0"
        (onClick)="clearFilters()"
      />
    </div>
  </div>

  <!-- ── Report cards ── -->
  <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
    @for (r of reportTypes; track r.key) {
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-5 shadow-sm flex flex-col gap-4"
      >
        <div class="flex items-start gap-3">
          <div
            class="w-11 h-11 rounded-lg bg-green-50 dark:bg-green-900/30 flex items-center justify-center shrink-0"
          >
            <i class="pi {{ r.icon }} text-green-600 dark:text-green-400 text-lg"></i>
          </div>
          <div class="flex-1 min-w-0">
            <h3 class="font-semibold text-gray-900 dark:text-gray-100">
              {{ 'REPORTS.' + r.key.toUpperCase() | translate }}
            </h3>
            <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
              {{ 'REPORTS.DESC.' + r.key.toUpperCase() | translate }}
            </p>
            @if (!r.dates) {
              <p
                class="text-xs text-amber-600 dark:text-amber-400 mt-1 inline-flex items-center gap-1"
              >
                <i class="pi pi-info-circle text-[10px]"></i>
                {{ 'REPORTS.STOCK_NOTE' | translate }}
              </p>
            }
          </div>
        </div>

        @if (r.key === 'low-stock') {
          <div class="flex items-center gap-2">
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400 shrink-0">{{
              'REPORTS.THRESHOLD' | translate
            }}</span>
            <input
              type="number"
              min="1"
              [(ngModel)]="lowStockThreshold"
              class="w-20 px-2 py-1 text-sm rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 focus:outline-none focus:border-emerald-400"
            />
            <span class="text-xs text-gray-400">{{ 'REPORTS.THRESHOLD_HINT' | translate }}</span>
          </div>
        }

        <div class="flex gap-2">
          <p-button
            class="flex-1"
            styleClass="w-full"
            [label]="'REPORTS.PDF' | translate"
            icon="pi pi-file-pdf"
            severity="danger"
            [outlined]="true"
            [loading]="isBusy(r.key, 'pdf')"
            [disabled]="anyBusy() && !isBusy(r.key, 'pdf')"
            (onClick)="download(r.key, 'pdf')"
          />
          <p-button
            class="flex-1"
            styleClass="w-full"
            [label]="'REPORTS.EXCEL' | translate"
            icon="pi pi-file-excel"
            severity="success"
            [loading]="isBusy(r.key, 'excel')"
            [disabled]="anyBusy() && !isBusy(r.key, 'excel')"
            (onClick)="download(r.key, 'excel')"
          />
        </div>
      </div>
    }
  </div>
</div>
